import React from "react";
import { SCREEN_COVER_CLASS } from "../../interactive-product-classes";

export const ScreenCover = ({ onCoverClick, customColor = undefined }) => {
	return (
		<div
			style={{ backgroundColor: customColor }}
			className={SCREEN_COVER_CLASS}
			onClick={onCoverClick}
		></div>
	);
};
